/* eslint-disable import/no-named-as-default */
import React from 'react';
import { array, object, oneOfType, string } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import classNames from 'classnames/bind';

import Accordion from 'yoda-core-components/lib/components/Accordion/accordion';

import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import LoaderAction from 'yoda-site-components/lib/actions/LoadingAction';

import { selectProductReviewID } from 'yoda-site-components/lib/selectors/ProductDetailsSelector';
import { selectPreferences } from 'yoda-site-components/lib/selectors/ContextSelector';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ProductInfoSelector, {
    getProductMattressSpec,
} from '../../selectors/ProductInfo/ProductInfoSelector';

import { pdpToolClickAnalytics } from '../../actions/AnalyticsAction';
import { renderMobileAccordion } from '../BazaarVoice/RenderBazaarVoice';

import * as styles from './ProductInfo.css';

const cx = classNames.bind(styles);
let reviewsAccordionIdx;
let questionsIdx;

class ProductInfo extends SiteComponent {
    static propTypes = {
        actions: oneOfType([object, array]),
        dataAutomationId: string,
        productReviewID: string,
        productDetails: oneOfType([object, array]).isRequired,
    };

    static defaultProps = {
        actions: {},
        dataAutomationId: '',
        productReviewID: '',
        productDetails: {},
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);

        this.mobileTabletRenderer = this.mobileTabletRenderer.bind(this);
        this.handleAccordionAnalytics = this.handleAccordionAnalytics.bind(this);
        this.state = {
            activeNode: 'prodDesc',
            initializeTurnToLib: false,
        };
    }

    /* istanbul ignore next */
    handleAccordionAnalytics(idx, title, newState) {
        let accordionTitle = title;

        if (typeof title === 'object') {
            if (typeof title.props.children === 'string') {
                accordionTitle = title.props.children;
            }

            if (
                typeof title.props.children === 'object' &&
                title.props.children[0] &&
                title.props.children[0].props &&
                title.props.children[0].props.children
            ) {
                accordionTitle = title.props.children[0].props.children;
            }
        }

        const accordionState = newState ? 'collapse' : 'expand';
        this.props.actions.pdpToolClickAnalytics(`${accordionTitle} ${accordionState}`);
    }

    /* istanbul ignore next */
    onAccordionSelect = (idx) => {
        if (
            !this.state.initializeTurnToLib &&
            (idx === questionsIdx || idx === reviewsAccordionIdx)
        ) {
            this.setState({
                initializeTurnToLib: true,
            });
        }
    };

    mobileTabletRenderer() {
        const {
            dataAutomationId,
            featureFlags,
            preferences,
            productDetails,
            productReviewID,
        } = this.props;

        const counter = 0;

        const ArrayOfAccordionSection = [];

        ArrayOfAccordionSection.push(
            ...renderMobileAccordion(featureFlags, productDetails, productReviewID)
        );
        /* istanbul ignore next */

        return (
            <ErrorBoundary>
                <Accordion
                    className={`${cx('rowBlock')} ${dt(['pb-10'])}`}
                    automationId={`${dataAutomationId}-accordion`}
                    onClick={this.onAccordionSelect}
                >
                    {ArrayOfAccordionSection}
                </Accordion>
            </ErrorBoundary>
        );
    }

    render() {
        return this.mobileTabletRenderer();
    }
}

const mapStateToProps = (state) => ({
    deviceType: state.context ? state.context.deviceType : {},
    featureFlags: state.context ? state.context.featureFlags : {},
    infoDetails: ProductInfoSelector(state),
    isMattressSpec: getProductMattressSpec(state),
    productReviewID: selectProductReviewID(state),
    preferences: selectPreferences(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...LoaderAction,
            pdpToolClickAnalytics,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductInfo);
